var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(function (require) {
            factory(require('jquery'));
        });
    } else {
        factory(window.jQuery);
    }
})(function ($) {

	CONFUSEDWEBSITE.setupGlobalNav = function () {
	    var $categoryLink = $('.' + CSSCONSTANTS.globalNavCategoryLinkClass),
            $subCategories = $('.' + CSSCONSTANTS.globalNavSubCategoriesClass),
            $categories = $('.' + CSSCONSTANTS.globalNavCategoryClass);

	    $categories.each(function() {
	        var $this = $(this),
				$promo = $this.find('.' + CSSCONSTANTS.globalNavPromoClass),
                $lastCol = $this.find('.global-nav-col:last-child');

	        $promo.prependTo($lastCol);

	        if (Modernizr.touch) {
	            var $categoryLink = $this.find('.' + CSSCONSTANTS.globalNavCategoryLinkClass),
                thisCategoryLinkHref = $categoryLink.attr('href'),
                thisCategoryLinkText = $categoryLink.text(),
                $thisCategoryAdditionalLinkContainer = $('<div/>', {
                    'class': 'clearfix'
                }),
                $thisCategoryAdditionalLink = $('<a/>', {
                    'class': 'global-nav__subcategories__category-link',

                    text: thisCategoryLinkText,
                    href: thisCategoryLinkHref
                }),
                $theseSubcategories = $this.find('.' + CSSCONSTANTS.globalNavSubCategoriesClass);

	            $thisCategoryAdditionalLink.appendTo($thisCategoryAdditionalLinkContainer);
	            $thisCategoryAdditionalLinkContainer.prependTo($theseSubcategories);

	        }
	    });

		$subCategories.each(function() {
			var $this = $(this),
				$associatedCategory = $this.prev('.' + CSSCONSTANTS.globalNavCategoryLinkClass);

			$associatedCategory.addClass(CSSCONSTANTS.globalNavCategoryLinkWithSubCategoriesClass);
				
		});

		if (Modernizr.touch) {
		    $subCategories.each(function () {
		        var $thisCategory = $(this),
                    $closeSubcategoryLink = $('<a/>', {
                    'class': CSSCONSTANTS.globalNavSubCategoriesCloseClass,
		            text: 'close menu',
		            href: '#'
		        });

		        $closeSubcategoryLink.appendTo($thisCategory);

		        $closeSubcategoryLink.on('click', function (e) {
		            e.preventDefault();
		            CONFUSEDWEBSITE.toggleSubNav($thisCategory.prev());
		        });
		    });
		   
		    $categoryLink.on('click',function (e) {
		        var $this = $(this),
                    $thisSubcategory = $this.next($subCategories);

		        e.preventDefault();
		        $categoryLink.not($this).removeClass(CSSCONSTANTS.globalNavCategoryOpenClass);
		        $subCategories.not($thisSubcategory).hide();
		        CONFUSEDWEBSITE.toggleSubNav($this);
		    });
		}

	    else {

		    $categoryLink.on('mouseenter', function () {
		 
	            CONFUSEDWEBSITE.showSubNav($(this));
	        });
	        $categoryLink.on('mouseleave', function () {
	            CONFUSEDWEBSITE.hideSubNav($(this));
	        });

	        $subCategories.on('mouseenter', function () {
	            $(this).show();
	            $(this).prev().addClass(CSSCONSTANTS.globalNavCategoryOpenClass);
	        });
	        $subCategories.on('mouseleave', function () {
	            CONFUSEDWEBSITE.hideSubNav($(this).prev());
	        });

		    // add keyboard & screenreader events
	        $('.' + CSSCONSTANTS.globalNavCategoriesClass).attr('role', 'menubar');
	        $('.' + CSSCONSTANTS.globalNavCategoryClass).attr('role', 'menuitem');
	        $subCategories.attr('role', 'menu');
	        $categoryLink.attr('aria-haspopup', 'true');

	        $categoryLink.on('keydown',function (e) {
	            var $this = $(this);
                   
	            if (e.keyCode === 13) {
	                e.preventDefault();
	                CONFUSEDWEBSITE.toggleSubNav($this);
	            }
	        });

	        $subCategories.each(function () {
	            var $this = $(this),
	                $lastLink = $this.find('a').last();

	            $lastLink.on('keydown',function (objEvent) {
	                if (objEvent.keyCode === 9) {
	                    CONFUSEDWEBSITE.toggleSubNav($this.prev());
	                }
	            });

	        });
	    }
	};

	var globalNavTimer;

	CONFUSEDWEBSITE.toggleSubNav = function (category) {
	    category.toggleClass(CSSCONSTANTS.globalNavCategoryOpenClass);
	    category.next('.' + CSSCONSTANTS.globalNavSubCategoriesClass).toggle();
	};

	CONFUSEDWEBSITE.showSubNav = function (category) {
	    globalNavTimer = setTimeout(function () {
	        category.addClass(CSSCONSTANTS.globalNavCategoryOpenClass);
	        category.next('.' + CSSCONSTANTS.globalNavSubCategoriesClass).show();
	    }, 250);
	};

	CONFUSEDWEBSITE.hideSubNav = function (category) {
	    clearTimeout(globalNavTimer);

	    category.removeClass(CSSCONSTANTS.globalNavCategoryOpenClass);
	    category.next('.' + CSSCONSTANTS.globalNavSubCategoriesClass).hide();

	};

	CONFUSEDWEBSITE.skipNav = function () {
	    $('.' + CSSCONSTANTS.skipNavLinkClass).on('click',function() {
	        $('#' + CSSCONSTANTS.mainId).attr('tabindex', -1).focus();
		});
	};

});